import { loadStep, storeStep, getListSteps, getTemplateInfo, createNewStep, deleteStep, updateTemplateInfo } from '../helper';
import Swal from 'sweetalert2';
import axios from 'axios';
import router from "~/router";
import GrapesJs from 'grapesjs';
export default (editor, opts = {}) => {

    const sm = editor.StorageManager;
    const storage_name = opts.storage_name;
    const order_step = opts.order_step;
    // Add custom storage to the editor
    sm.add(opts.storage_name, {

        template_info: {
            id: opts.template_id
        },
        list_steps: [],

        current_step: opts.step_id,
        order_step: null,
        config: {},
        async initStorage() {
            try {
                this.config = sm.getConfig();
                this.template_info = await this.loadTemplate(this.template_info.id);
                this.template = this.template_info;
                this.list_steps = await this.loadListSteps(this.template_info.uuid);
                this.current_step = opts.step_id;
                this.order_step = this.getOrderStep(this.current_step);

                return this;
            } catch (error) {
                console.error("Not init step storage!");
                throw error;
            }
        },
        getListSteps() {
            return this.list_steps;
        },
        setCurrentStep(step_id) {
            this.current_step = step_id;
            return this.current_step;
        },
        getCurrentStep() {
            return this.current_step;
        },
        getOrderStep(step_id) {
            try {
                let find = this.list_steps.find((item) => {
                    return step_id == item.id;
                });
                return find.order_step;
            } catch (error) {
                return null;
            }
        },

        hasSteps() {
            try {
                return this.list_steps.length > 0;
            } catch (error) {
                throw error;
            }
        },

        async selectStep(step_id) {

            editor.runCommand('create-spinner');
            editor.store();
            editor.once('storage:end:store', async () => {
                this.setCurrentStep(step_id);
                editor.load();

            });

            editor.once('storage:end:load', () => {
                editor.runCommand('remove-spinner');
            });
        },

        async deleteStep(step) {
            Swal.fire({
                title: 'Delete step?',
                text: "Do you want to delete the step?",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                heightAuto: false,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-primary mr-3 py-1 px-3',
                    cancelButton: 'btn btn-danger py-1 px-3'
                },
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await deleteStep(this.template, step);
                    const nextStep = this.getNextStepAfterDelete(step);
                    router.push({
                        name: 'step_builder',
                        params: {
                            stepId: nextStep.uuid,
                            templateId: this.template.uuid
                        }

                    });

                }
            });
        },

        findCurrentStepInfo() {
            const currentStepId = this.current_step;
            return this.list_steps.find((item) => {
                return item.uuid == currentStepId;
            });
        },

        getNextStepAfterDelete(step) {
            const steps = this.list_steps;
            const findIndex = steps.findIndex((item) => {
                return item.id == step.id
            });

            let nextStep = this.findCurrentStepInfo();
            if (nextStep.uuid == step.uuid) {
                if (steps[findIndex - 1]) {
                    nextStep = steps[findIndex - 1];

                } else if (steps[findIndex + 1]) {
                    nextStep = steps[findIndex + 1];
                }
            }
            return nextStep;
        },

        async deleteAllSteps() {
            const list_steps = this.list_steps;
            Swal.fire({
                title: 'Delete all step?',
                text: "Do you want delete all steps?",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                heightAuto: false,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-primary mr-3 py-1 px-3',
                    cancelButton: 'btn btn-danger py-1 px-3'
                },
            }).then(async (result) => {
                if (result.isConfirmed) {

                    for (let i = 0; i < list_steps.length; i++) {
                        const step = list_steps[i];
                        try {
                            await deleteStep(step.id);
                        } catch (error) {
                            console.log(error);
                        }
                    }

                    await sm_steps.cloneTemplate();

                }
            });
        },

        /**
         * @description: Create a new step blank. 
         */

        async createStepBlank() {

            try {
                const list_steps = this.list_steps;
                const template_info = this.template_info;
                const data_step = {
                    gjs_css: "",
                    gjs_assets: "",
                    gjs_components: "",
                    gjs_html: "",
                    gjs_styles: ""
                }

                let new_step = await createNewStep(template_info.id, list_steps.length, data_step);

                router.push({
                    name: 'step_builder',
                    params: {
                        stepId: new_step.id,
                        templateId: opts.template_id
                    }

                });

            } catch (error) {
                throw new Error("Error create step blank");
            }


        },

        async cloneTemplate() {

            try {

                const template_info = this.template_info;
                const list_steps = this.list_steps;

                let { gjs_css, gjs_assets, gjs_components, gjs_html, gjs_styles } = template_info;


                const data_step = {
                    gjs_css,
                    gjs_assets,
                    gjs_components,
                    gjs_html,
                    gjs_styles
                }


                const new_step = await createNewStep(template_info.id, list_steps.length, data_step);

                router.push({
                    name: 'step_builder',
                    params: {
                        stepId: new_step.id,
                        templateId: opts.template_id
                    }

                });

            } catch (error) {
                throw new Error("Error clone template");
            }

        },

        findComponentByType(components = [], component_type) {

            for (let i = 0; i < components.length; i++) {
                const component = components[i];
                if (component.type == component_type) {
                    return component;
                } else if (component.components && component.components.length > 0) {
                    let find_r = this.findComponentByType(component.components, component_type);
                    if (find_r) {
                        return find_r;
                    }
                }

            }

            return false;
        },

        removeComponentByType(components = [], component_type) {
            let clean_components = [];
            for (let i = 0; i < components.length; i++) {
                const component = components[i];

                if (component.components && component.components.length > 0) {
                    component.components = this.removeComponentByType(component.components, component_type);
                }

                if (component.type != component_type) {
                    clean_components.push(component);
                }
            }
            return clean_components;
        },

        async cloneStep(step) {
            await axios({
                url: `/templates.api/${this.template.uuid}/steps/${step.uuid}/clone`,
                method: "POST",
            });

            this.list_steps = await this.loadListSteps(this.template.uuid);

            router.push({
                name: 'step_builder',
                params: {
                    stepId: this.getLastStep().uuid,
                    templateId: this.template.uuid
                }

            });
        },

        getLastStep() {
            return this.list_steps.at(-1);
        },

        async loadTemplate(template_id) {
            try {
                let template_info = await getTemplateInfo(template_id);
                return template_info;
            } catch (error) {
                console.error('Not load template')
                throw error;
            }
        },
        async loadListSteps(uuid) {

            try {
                return await getListSteps(uuid);
            } catch (error) {
                console.log(error);
                return [];
            }

        },
        async updateOrderToDelete(step_id_deleted) {
            for (let i = 0; i < this.list_steps.length; i++) {
                if (this.list_steps[i].id == step_id_deleted) {
                    for (let j = i + 1; j < this.list_steps.length; j++) {
                        const step = this.list_steps[j];
                        await storeStep(step.id, { order_step: step.order_step - 1 });
                    }
                    break;
                }
            }
            await this.loadListSteps(this.template_info.uuid);
            return this.list_steps;
        },
        async updateStep({ id, order_step }) {
            return await storeStep(id, { order_step });
        },
        isActive() {
            if (sm.getCurrent() == opts.storage_name)
                return true;
            else
                return false;
        },

        /**
         * @description: Redirect to step builder, if not exist a step create a new one.
         */
        async activeStorageStep() {

            await this.initStorage();
            if (!this.hasSteps() || this.template_info.is_template_step !== 1) {
                await updateTemplateInfo(this.template_info.uuid, {
                    is_template_step: 1
                })
                this.cloneTemplate();
                return;
            }


            let step_id = this.list_steps[0].id;
            router.push({
                name: 'step_builder',
                params: {
                    stepId: step_id,
                    templateId: opts.template_id
                }
            });
            return;

        },

        /**
         * @description: Redirect to template builder
         */
        disableStorageStep() {
            router.push({
                name: 'landing_builder',
                params: {
                    uuid: this.template_info.uuid
                }
            });
        },
        /**
         * Load the data
         * @param  {Array} keys Array containing values to load, eg, ['gjs-components', 'gjs-style', ...]
         * @param  {Function} clb Callback function to call when the load is ended
         * @param  {Function} clbErr Callback function to call in case of errors
         */
        async load(keys, clb, clbErr) {

            const result = {};

            await this.initStorage();
            if (!this.hasSteps()) {
                clbErr({ code: 700, message: "There are no steps registered" });
                return;
            }
            if (!this.current_step) {
                clbErr({ code: 701, message: "Current step undefined" });
                return;
            }
            try {
                let config = {
                    method: 'get',
                    url: '/template_step/' + this.current_step,
                };
                // await data of the new step rank.
                const { data } = await axios(config);
                keys.forEach(key => {
                    const value = data[key];

                    if (value || value == '') {
                        result[key] = value;
                    }
                    if ((!value || value.length == 0) && (key == 'gjs_components' || key == 'gjs_html')) {
                        editor.runCommand('core:canvas-clear');
                    }
                });
            } catch (e) {
                console.log(e);
                clbErr(e);
            }

            // Might be called inside some async method
            clb(result);
        },

        /**
         * Store the data
         * @param  {Object} data Data object to store
         * @param  {Function} clb Callback function to call when the load is ended
         * @param  {Function} clbErr Callback function to call in case of errors
         */
        async store(data, clb, clbErr) {
            //console.log("Store....");

            try {
                await this.initStorage();
                if (!this.hasSteps()) {
                    clbErr();
                }
                if (!this.current_step) {
                    clbErr({ code: 701, message: "Current step undefined" });
                }


                let config = {
                    method: 'PUT',
                    // url: '/template_step/' + this.current_step,
                    url: `/templates.api/${this.template_info.uuid}/steps/${this.current_step}/update`,
                    data
                };

                // await data of the new step rank.
                await axios(config);
            } catch (error) {
                console.log("Not store storage step!");
            }

            clb();
        }
    });

    editor.on('storage:error', async (err) => {
        const sm = editor.StorageManager;
        const sm_steps = sm.get(opts.storage_name);
        if (err) {
            // console.error(err.message);
            /* Any step registed */
            if (err.code == 700) {
                /* editor.runCommand('create-spinner'); */
                await sm_steps.cloneTemplate();
                /* editor.once('storage:end:load',() => {
                    console.log("remove spinner");
                    editor.runCommand('remove-spinner');
                }); */
            }
            /* Current step undifined */
            if (err.code == 701) {
                console.error(err.message);
            }
        }

    });

    /* editor.once('storage:load',async (data) =>{
        let sm = editor.StorageManager;
        let sm_steps = sm.get(opts.storage_name);
        if(data.is_template_step && !sm_steps.isActive()){
            await sm_steps.activeStorageStep();
        }
    }) */


};
